import type { ComponentProps, ReactNode } from 'react';
import { useGoToRegister } from '../../hooks/useGoToRegister';
import { Button } from '../ui/Button';

type RegisterCtaButtonProps = Omit<ComponentProps<typeof Button>, 'onClick' | 'type'> & {
  children: ReactNode;
};

export function RegisterCtaButton({ children, ...props }: RegisterCtaButtonProps) {
  const goToRegister = useGoToRegister();

  return (
    <Button type="button" {...props} onClick={() => void goToRegister()}>
      {children}
    </Button>
  );
}

export function RegisterCtaLink({ children }: { children: ReactNode }) {
  const goToRegister = useGoToRegister();

  return (
    <button type="button" className="ui-inline-link" onClick={() => void goToRegister()}>
      {children}
    </button>
  );
}
